import React, { Component } from 'react';
import { matchPath } from 'react-router';
import moment from 'moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as EventsActions, Selectors as EventsSelectors } from 'store/ducks/events';

import { Validate, Access } from 'common';
import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Events/components';

class Edit extends Component {
  state = {
    data: {
      name: '',
      price: 0,
      speaker_id: '',
      alias_speaker: '',
      type_id: [],
      description: '',
      date: null,
      date_end: null,
      date_sale_start: null,
      date_sale_end: null,
      local: Access.lockedLocal() ? Access.lockedLocal(true) : { value: '', label: 'Não Será na Loja' },
      local_id: [],
      vacancy: '',
      price_points: 0,
      experience_plan_ids: [],
      difficulty: null,
    },
    errors: {},
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Eventos', to: '/events' },
      { name: 'Lista de Eventos', to: '/events/list' },
      { name: 'Editar', to: '' },
    ],
  };

  componentDidMount() {
    const { getEventRequest } = this.props;
    getEventRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { event, user } = this.props;

    if (oldProps.event.loading && !event.loading) {
      const { local, type } = event.data.attributes;
      const localSelected = local ? { value: local.id, label: local.name } : { value: '', label: 'Não Será na Loja' };
      const typeSelected = type ? { value: type.id, label: type.name } : null;

      this.setState({
        data: {
          ...event.data.attributes,
          id: event.data.id,
          name: event.data.attributes.name,
          speaker_id: user.data.id,
          // price: event.data.attributes.price,
          difficulty: event.data.attributes.difficulty
            ? { value: event.data.attributes.difficulty.id, label: event.data.attributes.difficulty.name }
            : null,
          type: typeSelected,
          description: event.data.attributes.description,
          date: new Date(event.data.attributes.date),
          date_end: new Date(event.data.attributes.date_end),
          date_sale_start: new Date(event.data.attributes.date_sale_start),
          date_sale_end: new Date(event.data.attributes.date_sale_end),
          local: localSelected,
          alternative_location: event.data.attributes.alternative_location,
          vacancy: event.data.attributes.vacancy,
          number_confirmeds: event.data.attributes.number_confirmeds,
          price_points: event.data.attributes.price_points,
          alias_speaker: event.data.attributes.alias_speaker,
        },
      });
    }
  }

  handleGetID = () => {
    const { location } = this.props;

    const match = matchPath(location.pathname, { path: '/events/:id/edit' });
    const { id } = match.params;

    return id;
  };

  handleChange = data => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      name: {
        required: true,
      },

      description: {
        required: true,
      },

      vacancy: {
        required: true,
      },

      date: {
        required: true,
      },

      date_end: {
        required: true,
      },

      date_sale_start: {
        required: true,
      },

      date_sale_end: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    if (!this.handleValidate()) return null;

    const { data } = this.state;
    const { updateEventRequest, user } = this.props;

    updateEventRequest(this.handleGetID(), {
      event: {
        name: data.name,
        speaker_id: user.data.id,
        description: data.description,
        date: moment(data.date).format('YYYY-MM-DD HH:mm'),
        date_end: moment(data.date_end).format('YYYY-MM-DD HH:mm'),
        local_id: data.local.value,
        alternative_location: data.alternative_location,
        type_id: data.type.value,
        vacancy: data.vacancy,
        alias_speaker: data.alias_speaker,
        experience_plan_ids: data.experience_plan_ids.map(plan => plan.value),
        price_points: data.price_points,
        difficulty_id: data.difficulty !== null ? data.difficulty.value : null,
      },
    });
  };

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          errors={errors}
          edit
          saving={update.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

const mapState = state => ({
  event: {
    ...state.events.detail,
    data: EventsSelectors.detail(state.events.detail.data),
  },
  locations: state.events.locations,
  update: state.events.update,
  user: state.auth.user,
});

const mapActions = dispatch => bindActionCreators(EventsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);
